var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lDfault',{attrs:{"title":"个人教材信息"}},[_vm._v(" 个人教材信息 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }